'use strict';

exports.array = require('./array');
exports['boolean'] = require('./boolean');
exports['function'] = require('./function');
exports.number = require('./number');
exports.object = require('./object');
exports.string = require('./string');
exports.emitter = require('./emitter');



//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/utils/index.js
// module id = 1356
// module chunks = 0